import { CenteredFrame } from '../components/AppFrame'

/**
 * Route `/not-authorized` — where a 403 from `session-gate` lands.
 *
 * Says so plainly rather than showing an empty dashboard. That is the entire
 * reason session-gate exists; see ../auth/session-gate.ts.
 */
export function NotAuthorizedScreen() {
  return (
    <CenteredFrame>
      <h1>Not Authorized</h1>
      <p className="esl-muted" style={{ marginTop: 'var(--esl-space-3)' }}>
        This account is not set up for the ESL Vision rep portal. Please contact ESL.
      </p>
    </CenteredFrame>
  )
}
